import Service, {
  type DefaultDataShape,
} from 'ember-simple-auth/services/session';

export type SessionData = DefaultDataShape & {
  locale?: string | null;
};

export default class SessionService extends Service<SessionData> {}

declare module '@ember/service' {
  interface Registry {
    session: SessionService;
  }
}
